<template>
  <div class="plans row d-flex">
    <div class="flex sm12 xs12">
      <va-card :title="$t(`raffles.cards.update`)">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(upload)">
            <div class="row">
              <div class="flex md12">
                <ValidationProvider rules="required" name="Titulo do Sorteio" v-slot="{ errors }">
                  <va-input
                    v-model="raffle.name"
                    class="mt-2"
                    :label="$t('raffles.forms.nameLabel')"
                    :placeholder="$t('raffles.forms.namePlaceholder')"
                    :success="errors.length == 0 && raffle.name.length > 0"
                    :error="errors.length > 0"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider rules="required" name="Autorização" v-slot="{ errors }">
                  <va-input
                    v-model="raffle.authorization"
                    class="mt-2"
                    :label="$t('raffles.forms.authorizationLabel')"
                    :placeholder="$t('raffles.forms.authorizationPlaceholder')"
                    :success="errors.length == 0 && raffle.authorization.length > 0"
                    :error="errors.length > 0"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider rules="required" name="Data e Hora do Sorteio" v-slot="{ errors }">
                  <va-date-picker
                    :label="$t('raffles.forms.datetimeLabel')"
                    :placeholder="$t('raffles.forms.datetimePlaceholder')"
                    :config="{enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true}"
                    :success="errors.length == 0 && raffle.datetime.length > 0"
                    :error="errors.length > 0"
                    :messages="errors"
                    v-model="raffle.datetime"
                  />
                </ValidationProvider>
                <div v-if='oldImage.length > 0' class="form-group mt-3">
                  <img
                    :src="$store.getters['environment/cdn'] + '/raffles/' + oldImage"
                    style="height: 30vh; max-width: 100%;"
                  >
                </div>
                <ValidationProvider name="Imagem" :rules="oldImage.length > 0 ? '' : 'required'" v-slot="{ errors }">
                  <div class="form-group mt-3">
                    <label
                      class="va-input__container__label position"
                      style="color: rgb(108, 127, 238);">
                      {{$t('raffles.prizes.forms.imageLabel')}}
                    </label>
                    <va-file-upload
                      type="single"
                      v-model="image"
                    />
                    <ErrorMessages :errors='errors'/>
                  </div>
                </ValidationProvider>
                <div class="d-flex mt-3">
                  <va-button
                    type="submit"
                    :disabled="buttonSubmitDisabled"
                    color="success"
                    class="my-0">
                    {{ textSubmit }}
                  </va-button>
                  <va-button
                    type="button"
                    class="my-0"
                    color="danger"
                    :to="{ name: 'raffles'}">
                    {{ $t("forms.back") }}
                  </va-button>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </va-card>
    </div>
    <Prizes :raffleId="raffleId"></Prizes>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ErrorMessages from '../utils/ErrorMessages'
import Prizes from './components/Prizes'
export default {
  name: 'RafflesUpdate',
  components: {
    Prizes,
    ErrorMessages,
  },
  props: {
    raffleId: {
      required: true,
    },
  },
  data () {
    return {
      raffle: {
        name: '',
        authorization: '',
        datetime: '',
        image: '',
      },
      oldImage: '',
      image: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },

  apollo: {
    raffle: {
      query: gql`
      query MyQuery($id: Int!) {
        raffle: raffle_by_pk(id: $id) {
          name
          authorization: authorization_number
          datetime
          image
        }
      }
      `,
      variables () {
        return {
          id: this.raffleId,
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          if (data.raffle && data.raffle.image.length > 0) {
            this.oldImage = data.raffle.image
            data.raffle.image = ''
          }
        }
      },
    },
  },
  watch: {
    image (value) {
      if (value.length > 0) {
        this.raffle.image = value[0].name
      }
    },
  },
  methods: {
    upload () {
      if (this.raffle.image.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.image[0])
        formData.append('path', 'raffles')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldImage)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.raffle.image = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.raffle.image = this.oldImage
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, authorization, datetime, image } = this.raffle
      const self = this
      this.$apollo
        .mutate({
          mutation: gql`
                mutation MyMutation($name: String, $authorization: String, $datetime: timestamp, $image: String, $id: Int!) {
                  update_raffle_by_pk(pk_columns: {id: $id}, _set: {name: $name, authorization_number: $authorization, datetime: $datetime, image: $image}) {
                    id
                  }
                }
                `,
          variables: {
            name,
            authorization,
            datetime,
            image,
            id: this.raffleId,
          },
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.showToast(
            self.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.showToast(
            self.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
